module.exports = __webpack_public_path__ + "static/media/viewsIcon.bec498a5.svg";